export default {
    icon: "cubes",
    name: "Estoque Bruto",
    subLinks: [
        {
            name: "Produto",
            route: "/gross-product/search",
            pagePermissions: [
                "gross-product-search",
                "gross-product-create",
                "gross-product-edit",
                "gross-product-delete",
            ],
        },
        {
            name: "Entrada / Saída",
            route: "/gross-inventory/search",
            pagePermissions: [
                "gross-inventorie-search",
                "gross-inventorie-create",
            ],
        },
        {
            name: "Pedido",
            route: "/order-part/search",
            pagePermissions: [
                "order-part-search",
                "order-part-create",
                "order-part-edit",
                "order-part-delete",
            ],
        },
    ],

    pageNavCheck: [
        "gross-product-search",
        "gross-product-create",
        "gross-product-edit",
        "gross-product-delete",
        "gross-inventorie-search",
        "gross-inventorie-create",
        "order-part-search",
        "order-part-create",
        "order-part-edit",
        "order-part-delete",
    ]
}
